import React from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {getBidContacts} from "../../actions/bidcontacts";
import {codeProjection} from "../../projections";
import {Redirect} from "react-router";
import {ContactsView} from "../Boilerplate/ContactsView";
import {Button, Card, Col, Icon, Progress, Row, Tooltip} from "antd";
import {getUsersQuery} from "../../actions/users";
import {currentEffectiveUserId, searchState} from "../../reducers/ui";
import {createSelector} from "reselect/es"; // fix for Webstorm IDE code analysis
import * as R from 'ramda';
import {codeTables} from "../../codes";
import {getMyCompany} from "../../actions/companies";
import * as PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {FileController} from "../Boilerplate/FileController";
import {PROJECT} from "../../services";
import SearchBox from "../Boilerplate/SearchBox";
import {convertBidToProject} from "../../actions/bids";
import Spinner from "react-spinkit";

class DelayedRedirect extends React.Component {
  static propTypes = { delay: PropTypes.number, path: PropTypes.string };
  state = { redirect: false };

  componentDidMount = () => this.timeout = setTimeout(() => this.setState({ redirect: true }), this.props.delay);

  componentWillUnmount = () => clearTimeout(this.timeout);

  render() {
    return this.state.redirect ? <Redirect to={this.props.path}/> : null;
  }
}

class BidConvert extends React.Component {
  state = { step: 0, contacts: [] };

  handleSearch = searchTerm => {
    this.setState({ searchTerm });
  };

  RenderNext = () => <Row>
    <Col style={{ textAlign: 'center' }}>
      <Button type='caret-right' onClick={() => this.setState({ step: this.state.step + 1 })}>Next</Button>
    </Col>
  </Row>;

  handleAdd = id => () => this.setState({ contacts: [...this.state.contacts, id] });

  handleDelete = id => () => this.setState({ contacts: this.state.contacts.filter(i => i !== id) });

  renderContacts() {
    const { onConvert, match } = this.props;
    const { searchTerm = null, contacts, step } = this.state;
    return <Card
      title='Add Contacts to Project'
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
        <div/>
        <SearchBox
          placeholder="Search by name, company, email, phone, city, or state"
          onChange={this.handleSearch}
          className='contact-search control-search'
          interactive
        />
      </div>
      {searchTerm ?
        <SearchBidContacts {...this.props} contacts={contacts} searchTerm={searchTerm} match={match}
                           onAdd={id => this.handleAdd(id)} onDelete={id => this.handleDelete(id)}/> :
        <AllBidContacts {...this.props} contacts={contacts}
                        onAdd={id => this.handleAdd(id)} onDelete={id => this.handleDelete(id)}/>}
      <Col style={{ textAlign: 'center' }}>
        <Button
          onClick={() => {
            onConvert && onConvert(contacts);
            this.setState({ step: step + 1 });
          }}
          type='caret-right'
        >Next</Button>
      </Col>
    </Card>;
  }

  renderFiles() {
    const { project } = this.props;
    const docKey = ['project', 'resource', 'id'];
    const subDocKey = null;
    const indexType = 'project';
    const topLevelName = 'Project';
    let ProjectFiles = !project ? null : FileController(PROJECT, indexType, docKey, subDocKey, topLevelName);

    return <Card
      title='Upload Files'
    >
      <Row className='bid-dashboard-info'>
        {!project ? <div><Spinner name='line-scale'/></div> :
          <ProjectFiles project={project}/>}
      </Row>
      <this.RenderNext/>
    </Card>;
  }

  renderDone() {
    const { projectId } = this.props;
    // TODO: Switch to project link
    return <Card>
      <DelayedRedirect delay={30000} path={`/projects/${projectId}`}/>
      <h1 style={{textAlign: 'center'}}>Complete! <Icon type='check-circle'/></h1>
      <Row>
        <Col span={18} offset={3}>
          <p>Your bid has been converted into a project for ongoing work and document tracking. The contacts and files
            you have provided have been added to the project. You may now begin to add documents, such as submittals,
            tasks, and daily logs, to your project.</p>
          <p>Redirecting to project in 30 seconds...</p>
          <p>... or <Link to={`/projects/${projectId}`}><Button size='small'>click here</Button></Link> to go now.</p>
        </Col>
      </Row>
    </Card>;
  }

  render() {
    const { bid } = this.props;
    let strokeColor = {'0%': '#2d9905'};
    if (this.state.step < 2) strokeColor['130%'] = '#3364a0';
    else strokeColor['65%'] = '#3364a0';
    return <div>
      <Row style={{maxWidth: 1200, margin: 'auto'}} className='bid-dashboard-info'>
        <Col>
          <Card title={<React.Fragment>Converting {bid.resource.name} to project...</React.Fragment>}
          style={{textAlign: 'center'}}>
            {this.state.step+1}/3
            <Progress
              strokeColor={strokeColor}
              status='active'
              percent={100*(this.state.step/2)}
              showInfo={false}
            />
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* Current step */}
          {this.state.step === 0 ? this.renderContacts() : this.state.step === 1 ? this.renderFiles() : this.renderDone()}
        </Col>
      </Row>
    </div>;
  }
}

const getProfile = state => R.view(R.lensPath(['profile']), state);

const _getMyCompany = createSelector(
  getProfile,
  state => state.companies,
  (profile, companies) => R.path(['data', profile.companyid, 'resource'], companies)
);

const getCurrentBidId = (state, props) => props.match.params.bidId;

const getCurrentBid = createSelector(
  getCurrentBidId,
  state => state.view,
  (bidId, view) => R.path(['data', bidId], view)
);

const getConvertedProjectId = createSelector(
  getCurrentBidId,
  state => R.path(['conversion'], state),
  (bidId, conversion) => R.prop(bidId, conversion)
);

const getConvertedProject = createSelector(
  getConvertedProjectId,
  state => state.view,
  (projectId, view) => R.path(['data', projectId], view)
);

const getCurrentBidContactList = createSelector(
  getCurrentBidId,
  state => state.bidcontacts,
  (bidId, bidcontacts) => bidcontacts.data[bidId]
);

const mergedContacts = createSelector(
  getCurrentBidContactList,
  state => state.ui.userSearchResults,
  (bidContacts, searchContacts) => {
    bidContacts = bidContacts || {};
    return searchContacts.map(id => {
      if (bidContacts[id])
        return bidContacts[id];
      else
        return { contactuserid: id };
    });
  }
);

const getRealAllContacts = createSelector(
  getCurrentBidContactList,
  (list) => {
    if (!list) return [];
    list = Object.values(list);
    return list;
  }
);

const searchContacts = createSelector(
  getRealAllContacts,
  state => state.companies,
  (state, props) => new RegExp(props.searchTerm, 'i'),
  (list, companies, search) => list.filter(contact => {
    const company = R.path(['data', contact.companyid, 'resource'], companies) || {};
    // Extract searchable fields from user object and user company object
    const obj = (
      ({ firstname, lastname, title, email, phone, cell, fax, company: { companyname, address, address2, city, state, zip } }
      ) => ({ firstname, lastname, title, email, phone, cell, fax, companyname, address, address2, city, state, zip })
    )({ ...contact, company });
    return Object.values(obj)
      .map(i => search.test(i)) // Test search term against each field
      .filter(i => i).length; // Grab only results with one or more match
  })
);

const getAllContacts = createSelector(
  getRealAllContacts,
  currentEffectiveUserId,
  (list, currentUser) => list.filter(contact => contact.userinitialized && contact.contactuserid !== currentUser)
);

const mapCodes = (list, state) => list.map(codeProjection(['status'], codeTables.get('bidinvitestatus')));

const mapDispatchMaster = (dispatch, props) => {
  const {
    match: {
      params: { bidId }
    },
    history
  } = props;
  return {
    onMount: () => {
      dispatch(getMyCompany());
      return dispatch(getBidContacts(bidId));
    },
    onConvert: (inviteUserIds = []) => dispatch(convertBidToProject(bidId, inviteUserIds))
  };
};

const mapDispatchTabs = (dispatch, props) => {
  const {
    match: {
      params: { bidId }
    },
    history
  } = props;
  return {
    onSearch: (value) => dispatch(getUsersQuery(value)),
    path: ['bidcontacts', 'data', bidId],
  };
};

// const _codes = codes;
const _BidCardExtras = ({ contact, currentUser, onAdd, onDelete, contactList }) => (
  currentUser !== contact.contactuserid
    ? <React.Fragment>
      {!contactList.includes(contact.contactuserid) ? // User is not in list
        <Tooltip title={'Add user'}><Button size='small' icon='user-add' onClick={onAdd(contact.contactuserid)}/></Tooltip> :
        <Tooltip title={'Remove user'}><Button size='small' icon='user-delete' onClick={onDelete(contact.contactuserid)}/></Tooltip>}
    </React.Fragment>
    : null
);

const BidCardExtras = connect(
  (state, props) => ({
    currentUser: currentEffectiveUserId(state),
    contactList: props.contacts,
  }),
  (dispatch, props) => ({})
)(_BidCardExtras);

const SearchBidContacts = compose(
  connect(
    (state, props) => {
      let list = searchContacts(state, props);
      list = mapCodes(list, state);
      return {
        contacts: list,
        extras: contact => <BidCardExtras {...props} contact={contact} contacts={props.contacts}/>,
      };
    },
    mapDispatchTabs
  ),
)(ContactsView);

const AllBidContacts = compose(
  connect(
    (state, props) => {
      let list = getAllContacts(state, props);
      return {
        contacts: list,
        extras: contact => <BidCardExtras {...props} contact={contact} contacts={props.contacts}/>,
      };
    },
    mapDispatchTabs
  ),
)(ContactsView);

export default compose(
  connect(
    (state, props) => ({
      bidId: getCurrentBidId(state, props),
      bid: getCurrentBid(state, props),
      projectId: getConvertedProjectId(state, props),
      project: getConvertedProject(state, props),
      profile: getProfile(state),
      company: _getMyCompany(state),
      searchResults: mergedContacts(state, props),
      searchState: searchState(state, props),
    }),
    mapDispatchMaster,
  ),
)(BidConvert);



// WEBPACK FOOTER //
// ./src/components/Bids/BidConvert.js